"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const FOCUSED_OR_HOVERED_COLOR = 'blue500';
const BACKGROUND_COLORS = {
    dimmed: undefined,
    'focused-or-hovered': undefined,
    normal: undefined,
};
const HELP_TEXT_COLORS = {
    dimmed: 'grey700',
    'focused-or-hovered': undefined,
    normal: undefined,
};
const ICON_COLORS = {
    dimmed: 'grey400',
    'focused-or-hovered': FOCUSED_OR_HOVERED_COLOR,
    normal: undefined,
};
function getSelectionNameColors({ isEventCard, hasChangeLink, colorState, }) {
    const maybeBlueColor = isEventCard && !hasChangeLink ? FOCUSED_OR_HOVERED_COLOR : undefined;
    const SELECTION_NAME_COLORS = {
        dimmed: maybeBlueColor,
        'focused-or-hovered': FOCUSED_OR_HOVERED_COLOR,
        normal: maybeBlueColor,
    };
    return SELECTION_NAME_COLORS[colorState];
}
function getColorState({ isDimmed, isFocused, isHovered, }) {
    if (isFocused || isHovered) {
        return 'focused-or-hovered';
    }
    if (isDimmed) {
        return 'dimmed';
    }
    return 'normal';
}
function useSelectCardColors({ isDimmed, isEventCard, hasChangeLink, }) {
    const [isHovered, setIsHovered] = react_1.useState(false);
    const [isFocused, setIsFocused] = react_1.useState(false);
    const colorState = getColorState({ isDimmed, isFocused, isHovered });
    return {
        backgroundColor: BACKGROUND_COLORS[colorState],
        helpTextColor: HELP_TEXT_COLORS[colorState],
        iconColor: ICON_COLORS[colorState],
        selectionNameColor: getSelectionNameColors({
            isEventCard,
            hasChangeLink,
            colorState,
        }),
        onBlur: () => setIsFocused(false),
        onFocus: () => setIsFocused(true),
        onMouseEnter: () => setIsHovered(true),
        onMouseLeave: () => setIsHovered(false),
    };
}
exports.default = useSelectCardColors;
